import { debug } from '@/log';
import { call, Callback, on } from "@/services/RtcHub";

export abstract class RtcHubInstance {
  protected initialized = false;
  protected subscribedIds: string[] = [];

  protected abstract subscribeToEvents(): void;
  protected abstract startSubscription(id: string): void;
  protected abstract endSubscription(id: string): void;

  protected assertEventSubscription() {
    if (this.initialized) { return; }
    this.initialized = true;

    this.subscribeToEvents();
  }

  protected call(method: string, params: unknown) {
    this.assertEventSubscription();
    call(method, params);
  }

  protected on(event: string, callback: Callback) {
    on(event, callback);
  }

  public subscribe(id: string) {

    debug(`[RTC] subscribe: ${id}`);
    this.assertEventSubscription();

    if (this.subscribedIds.find((sid) => sid === id)) {
      debug(`[RTC] already subscribed to details: ${id}`);
      return;
    }

    this.startSubscription(id);

    this.subscribedIds.push(id);

    debug(`[RTC] subscribed to details: ${id}`);
  }

  public unsubscribe(id?: string) {
    // No id supplied: unsubscribe from all
    const idsToUnsubscribe = (id) ? [id] : this.subscribedIds;
    // TODO: fixme
    if (!idsToUnsubscribe.length) { return; }

    idsToUnsubscribe.forEach((id) => {
      if (!this.subscribedIds.includes(id)) { return; }

      this.subscribedIds.splice(this.subscribedIds.indexOf(id), 1);

      this.endSubscription(id);

      debug(`[RTC] unsubscribed from details: ${id}`);
    })
  }

}